export enum PermissionStatus {
    NotDetermined = 'not-determined',
    Authorized = 'authorized',
    Denied = 'denied',
    Restricted = 'restricted'
}
